import AttributeButton from "components/Button/AttributeButton";
import V2ModalForm from "components/ModalForm/V2ModalForm";
import ReferenceEventTimingForm from "./ReferenceEventTimingForm";
import { UseFormReturn } from "react-hook-form";
import PrescheduledRecurringEventTimingForm from "./PrescheduledRecurringEventTimingForm";
import { meetingTemplateTimingSummary } from "features/Resources/MeetingTemplate/helpers";
import DashedButton from "components/Button/DashedButton";

interface MeetingTimingWithButtonFormProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export default function MeetingTimingWithButtonForm({ form, disabled = false }: MeetingTimingWithButtonFormProps) {
  const { watch } = form;
  const [
    meetingType,
    referenceEvent,
    offset,
    offsetUnit,
    preferredTimeSlot,
    recurrenceRules,
    seriesStartsAt,
    durationMinutes,
    useSpecificTime,
    specificTimeOfDay,
  ] = watch([
    "meetingType",
    "referenceEvent",
    "offset",
    "offsetUnit",
    "preferredTimeSlot",
    "recurrenceRules",
    "seriesStartsAt",
    "durationMinutes",
    "useSpecificTime",
    "specificTimeOfDay",
  ]);

  const timingSummary = meetingTemplateTimingSummary({ meetingType, referenceEvent, offset, offsetUnit, preferredTimeSlot, recurrenceRules, seriesStartsAt, useSpecificTime, specificTimeOfDay });
  const descriptor = timingSummary ? `${durationMinutes} min; ${timingSummary}` : undefined;

  return disabled ? (
    <AttributeButton w="100%" display="flex" justifyContent="flex-start" bg="bg.control" disabled={disabled}>{descriptor}</AttributeButton>
  ) : (
    <V2ModalForm
      modalHeader=""
      size="lg"
      includeCloseButton={false}
      renderButton={(onOpen) => (
        descriptor ? (
          <AttributeButton w="100%" display="flex" justifyContent="flex-start" bg="bg.control" disabled={disabled} onClick={onOpen}>{descriptor}</AttributeButton>
        ) : (
          <DashedButton title="Define Schedule" onClick={onOpen} />
        )
      )}
      renderForm={(onClose) => {
        if (meetingType === "group_session_recurring") {
          return (
            <PrescheduledRecurringEventTimingForm form={form} onClose={onClose} />
          );
        }

        return (<ReferenceEventTimingForm form={form} onClose={onClose} />);
      }}
    />
  );
}
